import {
  validateEmail,
  validatePassword,
  validateNickname,
  validateBirthDate,
  isAtLeastFourteen,
} from '../password/nativeValidation';
export function credentialsError(f, t) {
  if (!validateEmail(f.email)) return t('auth.validEmailRequired');
  if (!validatePassword(f.password)) return t('auth.passwordRule');
  if (f.password !== f.confirm) return t('auth.passwordMismatch');
  if (!f.agreed) return t('auth.agreeTermsRequired');
  return '';
}
export function detailError(f, social, t) {
  if (!validateNickname(f.nickname)) return t('auth.nicknameInvalid');
  if (!validateBirthDate(f.birthDate)) return t('auth.birthDateInvalid');
  if (!isAtLeastFourteen(f.birthDate)) return t('auth.minimumAgeRequired');
  if (!f.ageAgreed) return t('auth.ageAgreementRequired');
  if (social && !f.termsAgreed) return t('auth.agreeTermsRequired');
  return '';
}
export function latestBirthDate(now = new Date()) {
  const y = now.getFullYear() - 14,
    m = now.getMonth(),
    d = Math.min(now.getDate(), new Date(y, m + 1, 0).getDate());
  return `${y}-${String(m + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
}
export function withoutCallbackSecrets(search) {
  const p = new URLSearchParams(search);
  ['token', 'signupToken', 'code'].forEach((key) => p.delete(key));
  const clean = p.toString();
  return clean ? '?' + clean : '';
}
